import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/charts/shared")({
  loader: () => ({ collection: "shared" as const }),
});
